module.exports = __webpack_public_path__ + "static/media/icon_menu.b7855dcf.svg";